import { atom } from '@reatom/framework'
import BigNumber from 'bignumber.js'

import { CurrencyModel } from '@root/entities/currency'
import { nativePriceAtom } from '@root/features/realtime/atoms'
import { tradingWalletAtom } from '@root/features/trade/trading'

import type { PairModel } from '@root/entities/pair'
import type { SwapDirection } from '@root/entities/trade-type/model/trade-type'

export const reatomInstantTradeBalance = (args: {
  swapDirection: SwapDirection
  pair: PairModel
}) => {
  const { pair, swapDirection } = args

  const walletAssetAtom = atom((ctx) => {
    const tradingWallet = ctx.spy(tradingWalletAtom)
    if (!tradingWallet) {
      return undefined
    }
    const currency = swapDirection === 'buy' ? pair.base : pair.quote
    const currencyNormalized = CurrencyModel.isNativeOrWrapped(
      currency.network,
    )(currency)
      ? CurrencyModel.nativeOf(currency.network)
      : currency

    const asset = ctx.spy(tradingWallet.assetsByCurrency)[
      currencyNormalized.address
    ]

    return asset
  }, 'walletAssetAtom')

  const latestQuotePriceUsdAtom = atom((ctx) => {
    const asset = ctx.spy(walletAssetAtom)
    if (!asset) {
      return BigNumber(0)
    }
    return ctx.spy(pair.price).priceUsd
  }, 'latestQuotePriceUsdAtom')

  return atom((ctx) => {
    const currency = swapDirection === 'buy' ? pair.base : pair.quote
    const asset = ctx.spy(walletAssetAtom)

    if (!asset) {
      return BigNumber(0)
    }

    const balance = ctx.spy(asset.balance)
    if (CurrencyModel.isNativeOrWrapped(pair.network)(currency)) {
      const nativePrice = ctx.spy(nativePriceAtom)
      return nativePrice.multipliedBy(balance)
    }

    const latestPrice = ctx.spy(latestQuotePriceUsdAtom)

    return balance.multipliedBy(latestPrice)
  }, 'reatomInstantTradeBalance')
}
